import { QuestionsModel } from "./questions-model";

export class PaperPreviewSectionsModel {
    mandatoryQns: number;
    eachQnWeightage: number;
    marks: number;
    note: string;
    questions: QuestionsModel[];
    partName: string;
    constructor(
        mandatoryQns: number,
        eachQnWeightage: number,
        marks: number,
        note: string,
        questions: QuestionsModel[],
    ) {
        this.mandatoryQns = mandatoryQns;
        this.eachQnWeightage = eachQnWeightage;
        this.marks = marks;
        this.note = note;
        this.questions = questions;
    }
}